'use client';

import { useSearchParams } from 'next/navigation';
import { Center, Image, Stack, Text } from '@mantine/core';

export default function AnyError() {
  const searchParams = useSearchParams();

  const type = searchParams.get('type');

  return (
    <Center>
      <Stack align="center">
        <Image
          src="/images/errors/emptyState.svg"
          alt="Not Found"
          w={400}
        />

        <Stack gap={0}>
          <Text
            ta="center"
            fw={700}
            fs="md"
          >
            Oops... {type?.toLowerCase() || ''} tidak ditemukan
          </Text>

          <Text
            c="dimmed"
            ta="center"
            fs="xs"
          >
            Silahkan coba kembali
          </Text>
        </Stack>
      </Stack>
    </Center>
  );
}
